import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/plugins/axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    siteData: null
  },
  getters: {
  },
  mutations: {
    setSiteData(state, payload) {
      state.siteData = payload
    }
  },
  actions: {
    fetchSiteData({commit}) {
      axios.get('site')
        .then(({ data }) => {
          commit('setSiteData', data)
        })
    }
  },
  modules: {
  }
})
